import React from 'react';
import styled from 'styled-components';
import HeaderIcon from 'assets/LeaseHeaderIcon.png';
import { getTranslatedString } from 'helpers/i18n';
import replace from 'lodash/replace';
import join from 'lodash/join';
import { media } from 'helpers/MediaHelper';

const LeaseHeaderImage = styled.div`
  float: left;
  background-image: url('${(props) => props.url}');
  width: 96px;
  height: 85px;
  background-size: 96px 85px;
  ${media.mobile`
    float: none;
  `};
`;

const LeaseHeaderContents = styled.div`
  float: right;
  padding-left: 10px;
  ${media.mobile`
    float: none;
    padding-left: 0;
  `};
`;

const LeaseHeaderSmallTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  ${media.mobile`
    display: flex;
    justify-content: center;
    font-size: 18px;
  `};
`;

const LeaseHeaderTitle = styled.div`
  font-size: 24px;
  line-height: 32px;
  ${media.mobile`
    font-size: 30px;
    line-height: 38px;
  `};
`;

const ContainerDiv = styled.div`
  ${media.mobile`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 16px;
  `};
`;

export default function LeaseHeader({ lease }) {
  return (
    <ContainerDiv>
      <LeaseHeaderImage url={HeaderIcon} />
      <LeaseHeaderContents>
        <LeaseHeaderSmallTitle>
          {getTranslatedString('landlordPortal.reviewWizardPage.createLeaseFor')}
        </LeaseHeaderSmallTitle>
        <LeaseHeaderTitle>{lease.main_tenant_name}</LeaseHeaderTitle>
        <LeaseHeaderSmallTitle>
          {lease.cotenants_names.length > 0 &&
            `${getTranslatedString('landlordPortal.reviewWizardPage.with')} ${replace(
              join(lease.cotenants_names, ', '),
              /,([^,]*)$/,
              ` ${getTranslatedString('landlordPortal.reviewWizardPage.and')} $1`
            )}`}
        </LeaseHeaderSmallTitle>
      </LeaseHeaderContents>
    </ContainerDiv>
  );
}
